import React from "react";

import { Badge, Button, Divider, Skeleton, Stack, styled } from '@material-ui/core';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { StringParam, useQueryParam } from "use-query-params";
import { ProfileAvatar, UserNameLabel } from "../../components/UserPhoto/UserPhoto";
import { actions } from '../../services/support';

const Root = styled('div')({
  overflow: 'scroll'
});

const SupportChatHeader: React.FC = () => {
  const [ selectedChat ] = useQueryParam('id', StringParam);
  const state = useSelector((state: RootState) => state.support);
  const dispatch = useDispatch();

  const chat = state.chats.find(item => item.id === selectedChat);

  if (!selectedChat) {
    return null;
  }

  if (!chat) {
    return <Skeleton variant="text" />
  }

  const onMarkAllRead = () => {
    dispatch(actions.markAllAsRead(selectedChat));
  }

  const userId = chat.users[ 0 ] === 'admin' ? chat.users[ 1 ] : chat.users[ 0 ];

  return (
    <Root>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={2} alignItems="center">
          <ProfileAvatar userId={userId} />
          <UserNameLabel userId={userId} />
          <Badge badgeContent={chat.unseenMessagesCount[ 'admin' ]} color="secondary" />
        </Stack>
        <Button disabled={!Boolean(chat.unseenMessagesCount[ 'admin' ])} onClick={onMarkAllRead}>
          Mark as read
        </Button>
      </Stack>
      <Divider sx={{ mt: 1 }} />
    </Root>
  );
};

export default SupportChatHeader;